/**
 *
 * @description: 广发基金
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'gfjj';
const comein_channel = isBuild ? '1ddedaf8-9f19-415d-a10e-e2fe47f90b5d' : '7c6f1452-4e87-4012-b519-629ba03e8abb';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'gfjj';

// 广发基金Bridge类 - 继承基类，可以重写或添加新方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
    this.disableWaf = true;
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

export { Bridge };
